const initPlanDetailPage = () => {
    $("#reloaded-modal").modal('show');
    $("#invalid-zip-modal").modal({ backdrop: 'static', keyboard: false });
    $("#invalid-zip-modal").modal('show');
    $("#plan-unavailable-modal").modal({ backdrop: 'static', keyboard: false });
    $("#plan-unavailable-modal").modal('show');
}

export default initPlanDetailPage;